<template>
    <b-card title="">
        <h4 class="text-primary font-weight-bold mb-2">รายงานการจ่ายเงิน</h4>

        <b-row>
            <!-- <b-col md="6">
        <b-form-group label="IdCode" label-for="IdCode">
          <b-form-input id="IdCode" v-model="formUser.IdCode" placeholder="IdCode" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">ด่านชายแดน</h5>
          <b-form-select v-model="selectedBorder" :options="options"
            :class="{ 'is-invalid': showError && !selectedBorder }" />
          <div class="invalid-feedback">กรุณาเลือกด่านชายแดน</div>
        </b-form-group>
      </b-col> -->
            <b-col md="6">
                <b-form-group>
                    <h5 class="font-weight-bold">เลือกวันที่เริ่มต้นลงทะเบียน</h5>
                    <flat-pickr v-model="startDate" class="form-control" :config="DateConfig" />
                </b-form-group>
            </b-col>

            <b-col md="6">
                <b-form-group>
                    <h5 class="font-weight-bold">เลือกวันที่สิ้นสุดลงทะเบียน</h5>
                    <flat-pickr v-model="endDate" class="form-control" :config="DateConfig" />
                </b-form-group>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="6"></b-col>
            <!-- <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">วันที่เข้าประเทศไทย</h5>
          <flat-pickr
            v-model="in_dateDefault"
            class="form-control"
            :class="{ 'is-invalid': showError && !in_dateDefault }"
            :config="{ dateFormat: 'd-m-Y' }"
          />
          <div class="invalid-feedback">วันที่เข้าประเทศไทย</div>
        </b-form-group>
      </b-col> -->
            <b-col md="6">
                <br />
                <b-button variant="primary" @click.prevent="Getdata"> ค้นหา </b-button>
            </b-col>
            <br />
            <b-col md="6"></b-col>
            <b-col md="6">
                <br />
                <h4 class="text-primary font-weight-bold mb-2">
                    ตารางแสดงรายการนายหน้า
                </h4>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="6" sm="4" class="my-1">
                <b-form-group class="mb-0">
                    <label class="h5 d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
                    <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50"
                        @change="handleItemsPerPageChange" />
                </b-form-group>
            </b-col>
            <b-col md="6" class="my-1">
                <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm"
                    label-for="filterInput" class="h5 mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">
                                ยกเลิก
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <b-col cols="12">
            <b-table striped hover responsive :current-page="currentPage" :items="items" :fields="fields"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(actionEdit)="props">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                        </template>
                        <b-dropdown-item @click="editItem(props.item)">
                            <feather-icon icon="Edit2Icon" class="mr-50" />
                            <span>แก้ไข</span>
                        </b-dropdown-item>

                    </b-dropdown>
                </template>
                <template #cell(status)="data">
                    <span :class="{
                        'badge badge-success': data.item.status === 'confirmed',
                        'badge badge-danger': data.item.status === 'Inactive'
                    }">
                        {{ data.item.status }}
                    </span>
                </template>
                <template #cell(actionimg)="props">
                    <b-button variant="outline-primary" size="sm" @click="createImageAndSave(props.item)"
                        title="ดาวน์โหลดรูปภาพ">
                        <feather-icon icon="ImageIcon" />
                    </b-button>
                </template>
                <!-- 👇 CUSTOM ACTION COLUMN -->
                <template #cell(action)="props">
                    <b-button variant="outline-primary" size="sm" @click="handlePrint(props.item)"
                        title="ดาวน์โหลด PDF">
                        <feather-icon icon="FileTextIcon" />
                    </b-button>
                </template>
            </b-table>
        </b-col>
        <!-- Pagination -->
        <b-card v-show="true" class="p-0 mb-1" no-body>
            <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
                <div>
                    Showing {{ (currentPage - 1) * perPage + 1 }} to
                    {{ Math.min(currentPage * perPage, totalRows) }}
                    of {{ totalRows }} entries
                </div>
                <!-- {{currentPage}} -->
                <div class="bd-highlight">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                        @input="handlePageChange" class="mb-0" first-text="First" prev-text="Prev" next-text="Next"
                        last-text="Last" align="left" hide-goto-end-buttons />
                </div>
            </b-nav>
        </b-card>

        <b-modal id="edit-user-modal" v-model="showEditModal" title="แก้ไขข้อมูลผู้ลงทะเบียน" size="lg" hide-footer>
            <b-form @submit.prevent="saveEdit">
                <b-row>
                    <!-- ด่านชายแดน -->
                    <b-col md="6">
                        <b-form-group label="ด่านชายแดน" label-for="border-select">
                            <b-form-select id="border-select" v-model="editUser.BorderCheckpoint" :options="options"
                                text-field="text" value-field="value"
                                :class="{ 'is-invalid': showError && !editUser.BorderCheckpoint }" />
                            <div class="invalid-feedback">กรุณาเลือกด่านชายแดน</div>
                        </b-form-group>
                    </b-col>

                    <!-- แสดงจำนวนคิวที่เหลือ -->
                    <b-col md="6">
                        <b-card-text class="mt-2 mb-0 font-weight-bold"
                            v-if="editUser.BorderCheckpoint && count_data !== 0">
                            <span class="text-primary">
                                คิวที่เหลือ:
                                <strong>
                                    / ด่านชายแดน จังหวัด{{ editUser.BorderCheckpoint }} / {{ count_data }}
                                </strong>
                                คิว
                            </span>
                        </b-card-text>
                        <b-card-text class="text-danger font-weight-bold" v-else-if="!editUser.DateooutThailand">
                            กรุณาเลือกวันที่
                        </b-card-text>
                    </b-col>

                    <!-- วันที่ออกประเทศไทย -->
                    <b-col md="6">
                        <b-form-group label="วันที่เดินทางออกประเทศไทย">
                            <flat-pickr v-model="editUser.DateooutThailand" class="form-control"
                                :class="{ 'is-invalid': showError && !editUser.DateooutThailand }"
                                :config="outDateConfig" />
                            <div class="invalid-feedback">กรุณาเลือกวันที่ออกประเทศไทย</div>
                        </b-form-group>
                    </b-col>

                    <!-- วันที่เข้าประเทศไทย -->
                    <b-col md="6">
                        <b-form-group label="วันที่เข้าประเทศไทย">
                            <flat-pickr v-model="editUser.DateinThailand" class="form-control"
                                :class="{ 'is-invalid': showError && !editUser.DateinThailand }"
                                :config="{ dateFormat: 'd-m-Y' }" />
                            <div class="invalid-feedback">กรุณาเลือกวันที่เข้าประเทศไทย</div>
                        </b-form-group>
                    </b-col>

                    <!-- เลือกรอบ -->
                    <b-col md="12">
                        <h5 class="font-weight-bold">เลือกรอบ</h5>
                        <b-form-radio-group v-model="editUser.Round" name="round-selection" class="d-flex flex-wrap">
                            <b-form-radio value="รอบเช้า" class="mr-3">รอบเช้า</b-form-radio>
                            <b-form-radio value="รอบบ่าย">รอบบ่าย</b-form-radio>
                        </b-form-radio-group>
                    </b-col>
                </b-row>

                <!-- ปุ่มด้านล่าง -->
                <div class="d-flex justify-content-end mt-3">
                    <b-button variant="secondary" @click="showEditModal = false">ยกเลิก</b-button>
                    <b-button variant="primary" type="submit" class="ml-2">อัพเดทข้อมูล</b-button>
                </div>
            </b-form>
        </b-modal>
    </b-card>
</template>

<script>
import {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
} from "bootstrap-vue";
import { BCard, BCardText } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import { BNav } from "bootstrap-vue";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import QRCode from "qrcode";
import html2canvas from "html2canvas";

export default {
    components: {
        BTable,
        BAvatar,
        BBadge,
        BRow,
        BCard,
        BCardText,
        BCol,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
        BNav,
        flatPickr,
    },
    data() {
        return {
            perPage: 100,
            pageOptions: [25, 50, 100],
            totalPage: 0,
            totalRows: 0,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            sortDirection: "asc",
            isBusy: false,
            items: [],
            filter: null,
            filterOn: [],
            selectedBorder: null, // ✅ ค่า default (ตรงกับ value: null)
            fields: [
                { key: "select", label: "", sortable: false },
                { key: "no", label: "ลำดับที่" },
                { key: "IdCode", label: "รหัสนายหน้า" },
                { key: "status", label: "จำนวน" },
                // { key: "prefix", label: "คำนำหน้า" },
                // { key: "firstname", label: "ชื่อ" },
                // { key: "lastname", label: "นามสกุล" },
                // { key: "gender", label: "เพศ" },
                // { key: "cardSerialNumber", label: "card SerialNumber" },
                // { key: "registeredExitDateFormatted", label: "วันที่เดินทางออกประเทศไทย" },
                // { key: "registeredEntryDateFormatted", label: "วันที่เดินทางเข้าประเทศไทย" },
                // { key: "createdAtFormatted", label: "วันที่ลงทะเบียน" },
                // { key: "status", label: "สถานะ" },
                // { key: "actionimg", label: "ดาวน์โหลดรูปภาพ" }, // ✅ เพิ่มตรงนี้
                // { key: "action", label: "ดาวน์โหลด PDF" }, // ✅ เพิ่มตรงนี้
                // { key: "actionEdit", label: "แก้ไข" }, // ✅ เพิ่มตรงนี้

            ],
            in_dateDefault: null, // new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
            out_dateDefault: new Date(), //new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
            showError: false,
            outDateConfig: {
                dateFormat: "d-m-Y",
                // onChange: this.handleOutDateChange.bind(this),
            },
            DateConfig: {
                dateFormat: "Y-m-d", // format ที่ใช้ส่งจริง
                altInput: true,
                altFormat: "d-m-Y",  // format ที่แสดงผล
            },
            options: [],
            startDate: new Date(),
            endDate: new Date(),
            formUser: {
                reqcode: "",
                IdCode: "",
            },
            showEditModal: false,
            editUser: {},
            count_data: 0,
            showError: false,

        };
    },
    computed: {
        
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => ({ text: f.label, value: f.key }));
        },
    },
    created() {
        // this.getDataTable();
    },
    mounted() {
        //    this.getDataSelectOption();
        // Set the initial number of items
        //this.totalRows = this.items.length;
        if (this.items && this.items.length) {
            console.log(this.items.length);
        } else {
            console.log("ยังไม่มีข้อมูล items");
        }
    },
    methods: {
        statusText(status) {
            switch (status) {
                case 'confirmed':
                    return 'อนุมัติ'
                case 'rejected':
                    return 'ยกเลิก'
                case 'pending':
                    return 'รอดำเนินการ'
                default:
                    return status
            }
        },
        validate() {
            this.showError = !this.out_dateDefault;

            if (this.showError) {
                // หยุดการ submit
                return;
            }

            return true;
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`;
            this.infoModal.content = JSON.stringify(item, null, 2);
            this.$root.$emit("bv::show::modal", this.infoModal.id, button);
        },
        resetInfoModal() {
            this.infoModal.title = "";
            this.infoModal.content = "";
        },
        onFiltered(filteredItems) {
            console.log(filteredItems);
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async saveAsImage(item) {
            const element = document.getElementById("element-id-to-capture");
            if (!element) {
                console.error("Element to capture not found");
                return;
            }

            try {
                const canvas = await html2canvas(element);
                const dataUrl = canvas.toDataURL("image/png");

                const link = document.createElement("a");
                link.href = dataUrl;
                link.download = `Queue_${item.IdCode}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error("Error capturing element as image:", error);
            }
        },
        async createImageAndSave(item) {
            // ขนาดบัตร NFC แนวตั้ง (scale 4px/mm)
            const canvas = document.createElement("canvas");
            canvas.width = 216;  // กว้าง
            canvas.height = 342; // สูง
            const ctx = canvas.getContext("2d");

            // พื้นหลังขาว
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // เส้นขอบ
            ctx.strokeStyle = "#000";
            ctx.lineWidth = 2;
            ctx.strokeRect(0, 0, canvas.width, canvas.height);

            // ข้อความ
            ctx.fillStyle = "#000";
            ctx.font = "12px Arial";
            ctx.fillText(`${item.prefix} ${item.firstname} ${item.lastname}`, 10, 30);
            ctx.fillText(`ID: ${item.IdCode}`, 10, 50);
            ctx.fillText(`Sex: ${item.gender}`, 10, 70);
            ctx.fillText(`Nationality: ${item.Nationality}`, 10, 90);

            // ฟังก์ชันสร้าง QR
            function getQrImage(url) {
                return new Promise((resolve, reject) => {
                    QRCode.toDataURL(url, function (err, qrUrl) {
                        if (err) reject(err);
                        else {
                            const img = new Image();
                            img.onload = () => resolve(img);
                            img.onerror = reject;
                            img.src = qrUrl;
                        }
                    });
                });
            }

            try {
                const { VUE_APP_FONTEND_URL } = process.env;
                const qrUrl = `${VUE_APP_FONTEND_URL}booking?IdCode=${item.IdCode}&createdAt=${item.createdAtFormatted_img.replace(/-/g, '')}`;
                const img = await getQrImage(qrUrl);

                // วาง QR ด้านล่างตรงกลาง
                const qrSize = 100;
                const qrX = (canvas.width - qrSize) / 2;
                const qrY = canvas.height - qrSize - 20;
                ctx.drawImage(img, qrX, qrY, qrSize, qrSize);

                // เซฟไฟล์
                const link = document.createElement("a");
                link.href = canvas.toDataURL("image/png");
                link.download = `NFC_${item.IdCode}.png`;
                link.click();
            } catch (error) {
                console.error("Error creating NFC card image:", error);
            }
        },

        async handlePrint(item) {
            console.log("พิมพ์ข้อมูล:", item);

            // 🆕 กำหนดขนาดกระดาษเป็นขนาดบัตรพนักงาน (85.6mm x 54mm)
            const doc = new jsPDF({
                orientation: "landscape", // แนวนอน
                unit: "mm",
                format: [85.6, 54] // ขนาดบัตร
            });

            doc.setFontSize(10);

            const data = [
                ["Name", `${item.prefix} ${item.firstname} ${item.lastname}`],
                ["ID Card No.", item.IdCode],
                ["Sex", item.gender],
                ["Nationality", item.Nationality],
                // ["Appointment Date", item.registeredExitDateFormatted],
                // ["Card SerialNumber", item.cardSerialNumber],
            ];

            autoTable(doc, {
                startY: 5,
                body: data,
                styles: { fontSize: 7, cellPadding: 0.5 },
                margin: { left: 2, right: 2 }
            });

            const { VUE_APP_FONTEND_URL } = process.env;
            const url = `${VUE_APP_FONTEND_URL}booking?IdCode=${item.IdCode}&createdAt=${item.createdAtFormatted_img.replace(/-/g, '')}`;
            console.log("QR Code URL:", url);

            try {
                const qrDataUrl = await QRCode.toDataURL(url);
                const qrSize = 15; // เล็กลงให้พอดีกับบัตร
                const qrX = (85.6 - qrSize) / 2;
                const qrY = 30;
                doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
                doc.setFontSize(6);
                doc.text(`IdCode: ${item.IdCode}`, 85.6 / 2, qrY + qrSize + 5, { align: "center" });
            } catch (err) {
                console.error("❌ QR Code Error:", err);
            }

            doc.save(`Queue_${item.IdCode}.pdf`);
        }
        , async getDatauserFromCompany(_userId) {
            try {
                const jwt = JSON.parse(localStorage.getItem("company_jwt"));
                const params = {
                    companyId: jwt.companyId,
                    userId: _userId,
                };
                console.log("Request Params", params);
                const res = await axios.get(`${API}userFromCompany`, {
                    params,
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    },
                });
                console.log("API Response", res.data)
                return res.data.message.data;
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
            } finally {
                this.isBusy = false;
            }

            return;

        },
        formatDateFromYYYYMMDD(dateStr) {
            if (!dateStr || dateStr.length !== 8) return "";
            const year = dateStr.substring(0, 4);
            const month = dateStr.substring(4, 6);
            const day = dateStr.substring(6, 8);
            return `${day}-${month}-${year}`;
        },
        formatDateFromYYYYMMDD_pdf(dateStr) {
            if (!dateStr || dateStr.length !== 8) return "";
            const year = dateStr.substring(0, 4);
            const month = dateStr.substring(4, 6);
            const day = dateStr.substring(6, 8);
            return `${year}-${month}-${day}`;
        },
        editItem(item) {
            this.editUser = { ...item }; // clone item
            this.showEditModal = true;
            // เพิ่ม logic แก้ไข
            console.log("Edit item:", this.editUser);
            console.log(this.options);
            if (!this.editUser.BorderCheckpoint && this.editUser.stationName) {
                this.editUser.BorderCheckpoint = this.editUser.stationName;
            }
            this.editUser.DateooutThailand = this.editUser.registeredExitDateFormatted
                ? new Date(this.editUser.registeredExitDateFormatted.split("-").reverse().join("-"))
                : null;
            this.editUser.DateinThailand = this.editUser.registeredEntryDateFormatted
                ? new Date(this.editUser.registeredEntryDateFormatted.split("-").reverse().join("-"))
                : null;

            // คำนวณจำนวนคิวที่เหลือ
            this.count_data = 0;
            if (this.editUser.BorderCheckpoint) {
                const borderData = this.items.filter(item => item.BorderCheckpoint === this.editUser.BorderCheckpoint);
                this.count_data = borderData.length;
            }
            console.log("Count data:", this.count_data);
            this.editUser.Round = this.editUser.Round || "รอบเช้า"; // กำหนดค่าเริ่มต้นถ้าไม่มี
        },
        async saveEdit() {



            const { username, password, firstname, lastname } = this.formUser;
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));
            //   console.log(jwt);
            // console.log(this.items);
            // const res_data = this.items.map(async item => {
            const registeredExitDate = this.editUser.DateooutThailand;
            const [day, month, year] = registeredExitDate.split("-");

            const registeredEntryDate = this.editUser.DateinThailand;
            const [day2, month2, year2] = registeredEntryDate.split("-");

            const _data = {
                staffId: jwt.userId,
                entryId: this.editUser.entryId,
                stationName: this.editUser.BorderCheckpoint,
                shift: this.editUser.Round,
                registeredExitDate: `${year}${month}${day}`,
                registeredEntryDate: `${year2}${month2}${day2}`,
            }
            console.log("Data to send:", _data);
            axios
                .put(`${API}entry`, _data, {
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    },
                })
                .then(async (res) => {
                    console.log(res);
                    if (res.data.message == "Border entry updated successfully") {
                        this.$swal({
                            icon: "success",
                            title: "อัพเดทข้อมูล!",
                            text: "อัพเดทข้อมูลสำเร็จ",
                            showCancelButton: false,
                            showConfirmButton: true,
                            timer: 1500,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                        });
                    }
                })
                .catch(async (error) => {
                    console.log(error.response);
                });
            // });
            // 🔁 ส่งข้อมูลที่ถูกแก้ไขไปยัง backend หรือจัดการใน frontend
            console.log("บันทึกข้อมูล:", this.editUser);
            this.showEditModal = false;
            this.showError = false;
        },
        async Getdata() {
            // ตัวอย่างดึงข้อมูลจาก store (หรือ API)
            console.log(this.startDate);
            try {
                const jwt = JSON.parse(localStorage.getItem("company_jwt"));
                const formatDate = (dateObj) => {
                    if (typeof dateObj === 'string') {
                        dateObj = new Date(dateObj);
                    }
                    if (!(dateObj instanceof Date) || isNaN(dateObj)) return "";
                    const day = String(dateObj.getDate()).padStart(2, "0");
                    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                    const year = String(dateObj.getFullYear());
                    return `${day}-${month}-${year}`;
                };

                const startStr = formatDate(new Date(this.startDate));
                const endStr = formatDate(new Date(this.endDate));


                const [dayExit, monthExit, yearExit] = startStr.split("-");
                const [dayEntry, monthEntry, yearEntry] = endStr.split("-");

                let params = {
                    userId: jwt.userId,
                    includeCompany: 'true',
                    startDate: `${yearExit}${monthExit}${dayExit}`,
                    endDate: `${yearEntry}${monthEntry}${dayEntry}`,
                    emptyStationName: 'true',
                    _page: this.currentPage,
                    _limit: this.perPage,
                    _sort: "-1",
                };

                if (this.formUser.IdCode && this.formUser.IdCode.trim() !== "") {
                    params.IdCode = this.formUser.IdCode;
                }
                if (this.selectedBorder && this.selectedBorder.trim() !== "") {
                    params.stationName = this.selectedBorder;
                }
                console.log("Request Params", params);

                const res = await axios.get(`${API}entry`, {
                    params,
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    },
                });
                console.log("API Response", res.data.message.data);


                if (!res.data.message.data || !res.data.message.total) {
                    this.items = [];
                    this.totalRows = 0;
                    return;
                }

                const results = await Promise.all(
                    res.data.message.data.map(async (item, index) => {
                        const date = new Date(item.createdAt);
                        const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                        const createdAtFormatted_img = `${date.getFullYear()}-${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}`;
                        console.log("Item UserId:", item.userId);
                        const datausername = await this.getDatauserFromCompany(item.userId); // <- เรียก async ได้
                        console.log("datausername", datausername);
                        return {
                            ...item,
                            no: index + 1,
                            createdAtFormatted: formattedDate,
                            Nationality: datausername ? datausername.nationality : '',
                            shift: datausername ? datausername.shift : '',
                            registeredExitDateFormatted: this.formatDateFromYYYYMMDD(item.registeredExitDate),
                            registeredEntryDateFormatted: this.formatDateFromYYYYMMDD(item.registeredEntryDate),
                            formatDateFromYYYYMMDD_pdf: this.formatDateFromYYYYMMDD_pdf(item.registeredExitDate),
                            createdAtFormatted_img: createdAtFormatted_img,
                            _selected: false,
                            // datausername, // <- ใส่ข้อมูลที่ได้จาก async ไปใน object
                            cardSerialNumber: datausername ? datausername.cardSerialNumber : '',
                            prefix: datausername ? datausername.prefix : '',
                            firstname: datausername ? datausername.firstname : '',
                            lastname: datausername ? datausername.lastname : '',
                            gender: datausername ? datausername.gender : '',
                        };
                    })
                );
                // const results = res.data.message.data.map((item, index) => {
                //   const date = new Date(item.createdAt);
                //   const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                //   // const datausername = await getDatauserFromCompany()
                //   return {
                //     ...item,
                //     no: index + 1, // ลำดับเริ่มที่ 1
                //     createdAtFormatted: formattedDate,
                //     _selected: false, // เพิ่มให้ทุกแถวมี property นี้
                //   };
                // });

                console.log(results);
                this.items = results;
                this.totalRows = res.data.message.total;
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
            } finally {
                this.isBusy = false;
            }
            return;
        },

        async getDataTable() {

            const dd = await store.getters.getChang;
            //   const dd = await this.$store.dispatch("data_addqueue");
            console.log(dd);
            if (!dd || !dd.length) {
                // console.error("No data available");
                this.itemsdata = [];
                this.totalRows = 0;
                return;
            }
            this.items = dd[0];
            this.itemsdata = dd[0];
            this.totalRows = dd[0].length;
            return


            this.isBusy = true;
            try {
                const jwt = JSON.parse(localStorage.getItem("company_jwt"));

                const params = {
                    companyId: jwt.companyId,
                    userIdRule: jwt.userId,
                    startDate: "2024-07-01",
                    endDate: "2025-07-21",
                    _page: this.currentPage,
                    _limit: this.perPage,
                    _sort: "-1",
                };

                const res = await axios.get(`${API}SearchLog`, {
                    params,
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    },
                });

                console.log("API Response", res.data.message);
                console.log("API Response totalRows", res.data.message.total);
                this.itemsdata = res.data.message.data;
                this.totalRows = res.data.message.total;
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
            } finally {
                this.isBusy = false;
            }
        },
        async handlePageChange(page) {
            console.log(page);
            this.currentPage = page;
            this.items = [];

            await this.Getdata();
        },
        async handleItemsPerPageChange() {
            this.items = [];
            this.currentPage = 1;
            await this.Getdata();
        },
    },
};
</script>